module.exports = __webpack_public_path__ + "media/bootstrap-icons/reception-0-3a65d902.svg";